import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Accordion from "../../components/Acoordion";
import axios from "axios";
import ApiUrl from '../../config/app-config';

const baseURL = ApiUrl();

const FaqImportDetail = (props) => {
  /**case 별 */
  const contentId = useParams();
  const detailId = contentId.id;
  const [faqIm, setfaqIm] = useState("");



  /*header 영역*/
  const pageName = `FAQ ${detailId}`;
  const headerUi = {
    goback: false,
    closeAll: true,
  };
  useEffect(() => {
    props.onPageName(pageName);
  }, [faqIm]);

  useEffect(() => {
    props.onHeaderUi(headerUi);
  }, []);
  /**TESTDetail 받아오는 부분 */
  const [data, setData] = useState();
  async function getData() {
    props.onIsLoading(true);
    try {
      //응답 성공
      const response = await axios.get(`${baseURL}/v1/faq`, {
        params: {
          listSize: 50,
          totalListCount: 4,
          message: "Success",
          currentPageIndex: 1,
        },
      });
      const success = response.data;
      const result = success.result;
      props.onIsLoading(false);
      setData(result)
    } catch (error) {
      //응답 실패
      props.onIsLoading(false);
      props.onError(true);
      console.error(error);
    }
  }
  useEffect(() => {
    getData();
    //console.log(data)
  }, []);
  const faqImList = data && data.filter(
    (item) => String(item.faqType) === String(detailId) && item.state === false
  );

  return (
    <div className="container faq_import_list">
      <div className="accordion_wrap tabs">
        {faqImList &&
          faqImList.map((item) => {
            return <Accordion key={item.id} faqImList={item} />
          })}
      </div>
    </div>
  );
};
export default FaqImportDetail;
